export class AlterarSenhaMultiplasContasRequestEntity {
  /**
   * Token do link de recuperação. É ele que autoriza a troca e define quais contas serão
   * alteradas — a lista não é mais enviada pelo cliente.
   */
  token: string;
  senha: string;
  confirmacaoSenha: string;
}
